import { Box } from '@opendoor/bricks-next';

import type { EntryComponent } from '../../cms/entries/entries';
import type {
  IComponentImageCarousel,
  IImageAsset,
  IInstagramImageAsset,
} from '../../declarations/contentful';
import ImageAsset from './ImageAsset';
import InstagramImage from './InstagramImage';

const renderImageCarousel = (entry: IComponentImageCarousel) => {
  return (
    <Box className="embedded-entry-wrapper" $platform-web={{ gridColumn: '2 / -2' }}>
      <Box
        overflow="scroll"
        flexDirection="row"
        gap="$10x"
        position="relative"
        // align in the center on small screens to reduce excess spacing
        alignItems="center"
        paddingBottom="$6x"
        paddingRight="$6x"
        width="100%"
        $largerThanMD={{ marginRight: '-10%' }}
        hoverStyle={{ shadow: '$default' }}
      >
        {entry.fields.images?.map((x) => {
          if (x.sys.contentType.sys.id === 'instagramImageAsset') {
            return InstagramImage.render(x as IInstagramImageAsset);
          }
          if (x.sys.contentType.sys.id === 'imageAsset') {
            return ImageAsset.render(x as IImageAsset);
          }
          return null;
        })}
      </Box>
    </Box>
  );
};

const ImageCarouselComponent: EntryComponent<IComponentImageCarousel> = {
  render: renderImageCarousel,
};

export default ImageCarouselComponent;
